import { render } from "./Cart.vue?vue&type=template&id=32404370"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import "./Cart.vue?vue&type=style&index=0&id=32404370&lang=less"

import exportComponent from "D:\\perject\\suyuan\\.codex-tmp\\20260929-frontend-prod\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__